import { GET, POST } from '@/shared/api/requests';
import type { 
  SurveillanceAlert, 
  ProjectClientsResponse, 
  ClientUsersResponse,
  AlertsResponse
} from '../types/types';

// Note: apiClient already has /api/v1 as base URL, so we don't need to include it here
const BASE_URL = '/surveillance';

export const surveillanceReportApi = {
  /**
   * Create a new surveillance alert/report
   */
  createAlert: async (formData: FormData): Promise<SurveillanceAlert> => {
    const response = await POST<FormData>(
      `${BASE_URL}/alerts/`,
      formData
    );
    return response.data;
  },

  /**
   * Get clients for a specific project
   */
  getProjectClients: async (projectId: number): Promise<ProjectClientsResponse> => {
    const response = await GET(
      `/base/get-project-clients/${projectId}/`
    );
    return response.data;
  },

  /**
   * Get users for a specific client
   */
  getClientUsers: async (clientId: number): Promise<ClientUsersResponse> => {
    const response = await GET(
      `/base/get-client-users/${clientId}/`
    );
    return response.data;
  },

  /**
   * Get all alerts for a project with filtering and pagination
   */
  getAlerts: async (
    clientName: string, 
    projectName: string,
    params?: {
      search?: string;
      date?: string;
      result?: string;
      page?: number;
      page_size?: number;
    }
  ): Promise<AlertsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('q', params.search);
    if (params?.date) queryParams.append('date', params.date);
    if (params?.result) queryParams.append('result', params.result);
    if (params?.page) queryParams.append('page', String(params.page));
    if (params?.page_size) queryParams.append('page_size', String(params.page_size));

    const url = `${BASE_URL}/projects/${clientName}/${projectName}/alerts/${
      queryParams.toString() ? `?${queryParams.toString()}` : ''
    }`;
    
    const response = await GET(url);
    return response.data;
  },

  /**
   * Get result choices
   */
  getResultChoices: async (): Promise<Array<{ value: string; label: string }>> => {
    const response = await GET(
      `${BASE_URL}/alert-result-choices/`
    );
    return response.data.result_choices;
  },
};

